import { put, select, takeLatest } from "redux-saga/effects";

import { FieldAgentRecordBrief } from "@mapmycustomers/shared/types/chat/FieldAgentChat";
import { FiCatalogResponse } from "@mapmycustomers/shared/types/entity/fieldInsight";
import Organization from "@mapmycustomers/shared/types/Organization";
import ListResponse from "@mapmycustomers/shared/types/viewModel/ListResponse";

import { callApi } from "@app/store/api/callApi";
import { handleError } from "@app/store/errors/actions";
import { getOrganizationId } from "@app/store/iam";

import { fetchRecordBrief, fetchRecordChartCatalog } from "./actions";

function* onFetchRecordBrief({ payload }: ReturnType<typeof fetchRecordBrief.request>) {
  const { entityType, forceRefresh, recordId } = payload;
  try {
    const orgId: Organization["id"] = yield select(getOrganizationId);
    const brief: FieldAgentRecordBrief = yield callApi(
      "fetchFieldAgentRecordBrief",
      orgId,
      entityType,
      recordId,
      forceRefresh
    );
    yield put(fetchRecordBrief.success(brief));
  } catch (error) {
    yield put(fetchRecordBrief.failure(error));
    // No notification: a brief the rep never asked for is not worth a toast.
    yield put(handleError({ displayNotification: false, error }));
  }
}

function* onFetchRecordChartCatalog() {
  try {
    const orgId: Organization["id"] = yield select(getOrganizationId);
    const response: ListResponse<FiCatalogResponse> = yield callApi(
      "fetchFieldInsightsCharts",
      orgId
    );
    yield put(fetchRecordChartCatalog.success(response.data));
  } catch (error) {
    yield put(fetchRecordChartCatalog.failure(error));
    yield put(handleError({ displayNotification: false, error }));
  }
}

export function* recordBriefSaga() {
  yield takeLatest(fetchRecordBrief.request, onFetchRecordBrief);
  yield takeLatest(fetchRecordChartCatalog.request, onFetchRecordChartCatalog);
}
